import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class FirewallLogFailureReasonService extends Service {
	constructor(injector: Injector) {
		super("FirewallLogFailureReason", injector);
	}
	
	// API
	allActive(){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/AllActive`);
	}

	app_allActive(){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_AllActive`);
	}
}